module.exports = __webpack_public_path__ + "assets/icons/ccon-v2.svg";